// NOTE: esbuild移行の一環として、基本的に過去の仕様をそのままコピペしている
// esbuild移行時にinitializeProfileFormsをエクスポートできるようにする必要がある

function initializeProfileForms() {
  layoutProfileForms();
  attachProfileFormSubmitHandler();
}

function layoutProfileForms() {
  const addProfileForms = document.getElementsByClassName("addProfileForm");
  if (!addProfileForms.length) return;

  const width100 = $("#jsMainContent").innerWidth();
  $("#jsAddProfileFormArea").css({
    height: $(".addProfileForm:first").outerHeight(),
  });

  for (let i = 1; i < addProfileForms.length; i += 1) {
    // NOTE: addProfileForms[0]はスキップしている
    addProfileForms[i].style.left = `${width100}px`;
  }
}

function attachProfileFormSubmitHandler() {
  $(".addProfileForm form").on("submit", function (e) {
    e.preventDefault();

    const formData = new FormData(this);
    const url = $(this).attr("action");

    $.ajax({
      url,
      type: "PATCH",
      data: formData,
      dataType: "json",
      processData: false,
      contentType: false,
    })
      .done(() => handleProfileFormSubmission())
      .fail(() => alert("申し訳ございません。エラーが発生しました。"));
  });
}

function handleProfileFormSubmission() {
  removeCurrentProfileForm();
  showNextProfileForm();
}

function removeCurrentProfileForm() {
  $("#jsPhoneNumForm, #jsPasswordForm, #jsAdditionalEmailForm").remove();
}

function showNextProfileForm() {
  if (document.getElementsByClassName("addProfileForm").length) {
    const nextForm = $(".addProfileForm:first");
    $("#jsAddProfileFormArea").css({ height: nextForm.outerHeight() }, 600);
    nextForm.animate({ left: "0" }, 600);
  } else {
    const completeMessageElement = $("#jsAddProfileComplete");
    $("#jsAddProfileFormArea").css(
      { height: completeMessageElement.outerHeight() },
      400
    );
    completeMessageElement.fadeIn(400);
  }
}

// NOTE: esbuild はモジュールレベルの副作用がない純粋な関数宣言をバンドルから除外する
// Sprockets からの移行のため、グローバルアクセスを維持するために window に公開する

export {
  initializeProfileForms,
  layoutProfileForms,
  attachProfileFormSubmitHandler,
  handleProfileFormSubmission,
  removeCurrentProfileForm,
  showNextProfileForm,
};
